// LEGACY

window.showPreLoaderInContainer = function (container, additionalClasses) {
    if (typeof additionalClasses === 'undefined' || additionalClasses === null) {
        additionalClasses = '';
    }

    jQuery(container)
        .empty()
        .append(jQuery('<div />')
            .addClass('text-center mt-3 mb-3')
            .append(jQuery('<i />')
                .attr('src', '/assets/gfx/preloader-1.gif')
                .addClass('fa fa-spinner fa-pulse fa-5x fa-fw text-primary')
                .addClass(additionalClasses)
            )
        );
};


// window.PreLoader = function (div) {
//     jQuery(div).html('<div style="padding: 2px;" class="text-center"><img src="assets/gfx/preloader-1.gif" style="width: 150px"/><div>');
// }
//
// window.showPreLoaderContainer = function (container, additionalClasses) {
//     if (typeof additionalClasses === 'undefined' || additionalClasses === null) {
//         additionalClasses = '';
//     }
//
//     jQuery(container)
//         .empty()
//         .append(jQuery('<div />')
//             .addClass('text-center mt-3 mb-3')
//             .append(
//                 jQuery('<div />')
//                     .addClass(additionalClasses)
//             )
//         );
// };

//
// window.showPreLoaderInRelative = function (container, additionalClasses, idpreloader) {
//
//     if (typeof additionalClasses === 'undefined' || additionalClasses === null) {
//         additionalClasses = '';
//     }
//
//     if (typeof idpreloader === 'undefined' || idpreloader === null) {
//         idpreloader = '';
//     }
//
//     jQuery(container).prepend(
//         jQuery('<div />')
//             .addClass('preloader_relative')
//             .addClass(additionalClasses)
//             .attr('id', idpreloader));
// };

window.filterMoney = function (value) {
    return value
        .replace(',', '.')
        .replace(/[^0-9.]/g, '')
        .replace(/^([0-9]*(\.[0-9]{0,2})?).*$/, '$1');
};

window.ArrayToList = function (contener, ArrayData) {

    jQuery(contener).empty();

    var listcontener = jQuery(contener);
    listcontener.append('<ul/>');
    var list = jQuery(contener + ' ul');

    jQuery.each(ArrayData, function (key, value) {
        var listItem = jQuery('<li/>');
        list.append(listItem.append(value));
    });
};

window.email_validate = function (src) {
    var regex = /^[a-zA-Z0-9._-]+@([a-zA-Z0-9.-]+\.)+[a-zA-Z0-9.-]{2,8}$/;
    return regex.test(src);
};
